// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React, {useEffect} from 'react';

import {useDatadogRum} from '../../util/datadog/datadogRum';
import {Banner} from '../Banner';

export const MaxRunsWarningBanner = ({
  numRuns,
  location,
}: {
  numRuns: number;
  location: string;
}) => {
  const DD_RUM = useDatadogRum();

  useEffect(() => {
    DD_RUM.addAction('Max runs warning banner shown', {
      numRuns,
      location,
    });
  }, [numRuns, DD_RUM, location]);

  return (
    <Banner
      className="my-12 flex items-start justify-start gap-8 p-12 text-sm"
      variant="warning">
      <div className="flex items-center">
        <Icon name="warning" className="mt-1 h-18 w-18 shrink-0" />
        <p className="pl-12">
          Including a large number of runs may affect performance and usability.
        </p>
      </div>
    </Banner>
  );
};
